import React from 'react'
import { FiTrash } from 'react-icons/fi'
import { RiIncreaseDecreaseLine } from 'react-icons/ri'
import { Col, Collapse, Row } from 'reactstrap'
import { SimpleTitleCard } from 'styles/global'
import CardParametrizacao from './CardParametrizacao'
import { BiChevronDown } from 'react-icons/bi'
import { useSelector } from 'react-redux'
import { ApplicationState } from 'store'
import { PRODUTO } from 'store/modules/backoffice/produto/types'
import { ParametrizacaoProdutoReq } from 'models/backoffice/produto/type'
import * as produtoActions from 'store/modules/backoffice/produto/actions'
import useRedux from 'hooks/useRedux'
import InputCustom from 'components/Inputs'

const CardPmtPaga = () => {
  const { register, visualizacao, cardsState, invalids } = useSelector<
    ApplicationState,
    PRODUTO
  >((state) => state.produto)

  const { dispatch } = useRedux()

  type Field = keyof ParametrizacaoProdutoReq

  function onChange(value: string | number, field: Field) {
    dispatch(produtoActions.setRegister({ ...register, [field]: value }))
  }

  function onToggle() {
    dispatch(produtoActions.toggleCard(!cardsState.pmtPaga, 'pmtPaga'))
  }

  return (
    <CardParametrizacao>
      <div className="d-flex justify-content-between">
        <SimpleTitleCard color="#000" colorIcon="#000">
          <RiIncreaseDecreaseLine className="icon" />
          PMT paga
        </SimpleTitleCard>
        <BiChevronDown onClick={() => onToggle()} className="toggler" />
      </div>
      <Collapse isOpen={cardsState.pmtPaga}>
        <div className="d-flex flex-column row-gap-10">
          <Row>
            <Col>
              <label className="info-card">
                Regra de acordo com a instituição selecionada
              </label>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <label className="label-12">Quantidade</label>
              <InputCustom
                type="number"
                placeholder="Digite aqui"
                onChange={(e) => {
                  onChange(e.target.value, 'pmtPaga')
                }}
                value={register.pmtPaga || ''}
                disabled={visualizacao}
                min={0}
                invalid={invalids.pmtPaga}
              />
            </Col>
          </Row>
          <div className="linha-horizontal"></div>
          {!visualizacao && (
            <Row>
              <Col className="d-flex justify-content-end">
                <FiTrash
                  onClick={() => dispatch(produtoActions.cleanPmtPaga())}
                  className="icon-trash"
                />
              </Col>
            </Row>
          )}
        </div>
      </Collapse>
    </CardParametrizacao>
  )
}

export default CardPmtPaga
